import { Component, OnDestroy, OnInit } from '@angular/core';
import { DropdownTableColumn, IDropdownTableColumn, ITableColumn, NewTableEditorUserViewOptions, TableColumn } from 'new-table-editor';
import { forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { IUserTokenModel, StarbaseLoginService } from 'starbase-login';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { AppGlobalsService } from '../services/app-globals.service';
import { IEditCheck } from '../services/auth-guard.service';
import { SiteDataService } from '../services/site-data.service';
import { STContactDataService } from '../services/st-contact-data.service';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { LU_MaterialService, LU_MaterialServiceDetail, LU_STContactType, LU_Grid, LU_JobCategory, LU_JobCode, LU_MaterialSubCategory, LU_STUnitOfMeasure, LU_VehicleType, LU_Tax, LU_InvoiceBatch, LU_TermsModel } from 'scaletech-core';
import { FilterParams, ISelectable } from 'starbase-launcher';
import { LU_JobCodeService } from '../services/lookups/lu-job-code.service';
import { LU_GridService } from '../services/lookups/lu-grid.service';
import { LU_ContactTypeService } from '../services/lookups/lu-contact-type.service';
import { LU_JobCategoryService } from '../services/lookups/lu-job-category.service';
import { LU_MaterialServiceService } from '../services/lookups/lu-material-service.service';
import { LU_TaxService } from '../services/lookups/lu-tax.service';
import { LU_TermService } from '../services/lookups/lu-term.service';
import { LU_UnitOfMeasureService } from '../services/lookups/lu-unit-of-measure.service';
import { LU_VehicleTypeService } from '../services/lookups/lu-vehicle-type.service';
import { VehicleDataService } from '../services/vehicle-data.service';
import { LU_MaterialSubCategoryService } from '../services/lookups/lu-material-sub-category.service';
import { LU_InvoiceBatchService } from '../services/lookups/lu-invoice-batch.service';

@Component({
  selector: 'app-lookups',
  templateUrl: './lookups.component.html',
  styleUrls: ['./lookups.component.css']
})
export class LookupsComponent implements OnInit, OnDestroy, IEditCheck {

  isAdmin = false;
  darkMode = false;
  private currentUser: IUserTokenModel;
  public dropdownTypeDebounceTime;

  lookupTables: {
    name: string,
    id: string,
    columnDefs: ITableColumn[],
    tableViewOpts: NewTableEditorUserViewOptions,
    targetDivID: string
  }[] = [];
  logTables: {
    name: string,
    id: string,
    columnDefs: ITableColumn[],
    tableViewOpts: NewTableEditorUserViewOptions,
    targetDivID: string
  }[] = [];

  activeTables = [];
  taxList = [];
  termsList = [];
  matSvcData = [];
  matTypes = [];
  grids = [];
  mats = [];

  subscriptionArray: Subscription[] = [];
  uomWatcherSubscription: Subscription;
  taxWatcherSubscription: Subscription;
  termWatcherSubscription: Subscription;
  vehicleTypeWatcherSubscription: Subscription;

  constructor( public sbCmpMsgSvc: StarbaseComponentMessageService,
               protected modalSvc: StarbaseModalDialogService,
               public jobCodeService: LU_JobCodeService,
               public gridModelService: LU_GridService,
               public contactTypeService: LU_ContactTypeService,
               public jobCategoryService: LU_JobCategoryService,
               public materialsServices: LU_MaterialServiceService,
               public taxModelService: LU_TaxService,
               public uomSvc: LU_UnitOfMeasureService,
               public vehicleTypeSvc: LU_VehicleTypeService,
               public vehicleSvc: VehicleDataService,
               public contactSvc: STContactDataService,
               public matSubCategorySvc: LU_MaterialSubCategoryService,
               public termModelSvc: LU_TermService,
               public siteSvc: SiteDataService,
               public batchSvc: LU_InvoiceBatchService,
               public appGlobals: AppGlobalsService,
               private loginSvc: StarbaseLoginService) {

  }

  focusTable(table: {name: string, targetDivID: string}) {
    setTimeout(() =>
    document.querySelector(`#${table.targetDivID}`)
      .scrollIntoView({ behavior: 'smooth', block: 'start' }), 500); // wait for collapse anim
  }

  addMatSvcTax(info: LU_MaterialService) {
    const m = new LU_MaterialServiceDetail();
    m.matSvcUID = info.uid;

    if (!info.matSvcTaxes) {
      info.matSvcTaxes = [];
    }

    info.matSvcTaxes.push(m);
  }

  updateActiveTables(data: { name: string, active: boolean }) {
    if (data.active) { // edit mode is active, so add the table if it isn't already in the list
      if (!this.activeTables.find(a => a === data.name)) {
        this.activeTables.push(data.name);
      }
    } else { // edit mode is finished, so remove the table from the list.
      this.activeTables.splice(this.activeTables.findIndex(a => a === data.name), 1);
    }
    this.handleEditComplete(data);
  }

  unsavedChangesCheck(): Observable<boolean> | boolean {
    if (!this.activeTables.length) {
      return true;
    }
    const obs$ = new Subject<boolean>();
    const modal =
      new StarbaseModalOptions(
        'Discard data changes?',
        `You have unsaved changes. If you leave now those changes will be lost.`,
        [
          new StarbaseModalButton(
            'Yes',
          () => { obs$.next(true); this.modalSvc.closeModal('User chose yes'); }),
          new StarbaseModalButton(
            'No',
            () => { obs$.next(false); this.modalSvc.closeModal('User chose no'); })
        ],
        StarbaseModalTypes.Warning
      );
    modal.dismissable = false;
    this.modalSvc.postModal(modal);
    return obs$;
  }

  cancelTax(array: any[], i: number) {
    array.splice(i, 1);
  }

  deleteTax(taxUid: number) {

  }

  ngOnInit() {
    this.isAdmin = this.loginSvc.getUserModel().isAdmin();
    this.currentUser = this.loginSvc.getUserModel();
    if (!this.appGlobals.currentUser || this.appGlobals.currentUser !== this.currentUser.user) {
      this.appGlobals.currentUser = this.currentUser.user;
    }

    this.darkMode = this.appGlobals.getStoredDarkModeSetting();

    this.lookupTables = [
      {
        name: 'Contact Types',
        id: 'contactTypes',
        columnDefs: LU_STContactType.TableColumns(false),
        tableViewOpts: new NewTableEditorUserViewOptions(false, true, true, false, false),
        targetDivID: 'ctCollapse'
      },
      {
        name: 'Grid',
        id: 'grid',
        columnDefs: LU_Grid.TableColumns(false),
        tableViewOpts: new NewTableEditorUserViewOptions(false, true, true, false, false),
        targetDivID: 'gmCollapse'
      },
      {
        name: 'Job Categories',
        id: 'jobCategories',
        columnDefs: LU_JobCategory.TableColumns(false),
        tableViewOpts: new NewTableEditorUserViewOptions(false, true, true, false, false),
        targetDivID: 'jcatCollapse'
      },
      {
        name: 'Job Codes',
        id: 'jobCodes',
        columnDefs: LU_JobCode.TableColumns(false),
        tableViewOpts: new NewTableEditorUserViewOptions(false, true, true, false, false),
        targetDivID: 'jcCollapse'
      },
      {
        name: 'Materials and Services',
        id: 'matAndSvc',
        columnDefs: [],
        tableViewOpts: new NewTableEditorUserViewOptions(true, true, true, false, false),
        targetDivID: 'msCollapse'
      },
      {
        name: 'Material Subcategories',
        id: 'matSubCat',
        columnDefs: LU_MaterialSubCategory.TableColumns(false),
        tableViewOpts: new NewTableEditorUserViewOptions(false, true, true, false, false),
        targetDivID: 'mscCollapse'
      },
      {
        name: 'Taxes',
        id: 'taxes',
        columnDefs: [],
        tableViewOpts: new NewTableEditorUserViewOptions(true, true, true, false, false),
        targetDivID: 'txCollapse'
      },
      {
        name: 'Terms',
        id: 'terms',
        columnDefs: LU_TermsModel.TableColumns(false),
        tableViewOpts: new NewTableEditorUserViewOptions(true, true, true, false, false),
        targetDivID: 'trmCollapse'
      },
      {
        name: 'Units of Measure',
        id: 'uom',
        columnDefs: LU_STUnitOfMeasure.TableColumns(false),
        tableViewOpts: new NewTableEditorUserViewOptions(false, true, true, false, false),
        targetDivID: 'uomCollapse'
      },
      {
        name: 'Vehicle Type',
        id: 'vehicleType',
        columnDefs: LU_VehicleType.TableColumns(false,true,this.mats),
        tableViewOpts: new NewTableEditorUserViewOptions(false, true, true, false, false),
        targetDivID: 'vehicleTypeCollapse'
      }
    ];

    this.logTables = [
      {
        name: 'Batch Logs',
        id: 'batchLogs',
        columnDefs: [],
        tableViewOpts: new NewTableEditorUserViewOptions(false, true, true, false, false),
        targetDivID: 'batchLogCollapse'
      }
    ];

    this.dropdownTypeDebounceTime = this.appGlobals.dropdownTypeDebounceTime;

    this.uomWatcherSubscription = this.uomSvc.refreshTrigger$.subscribe(
      () => {
        this.uomSvc.getAllData(this.uomSvc.getAllUri).subscribe(
          (uoms) => {
            this.lookupTables[4].columnDefs = LU_MaterialService.TableColumns(false, uoms, this.matTypes, true, this.grids);
            this.lookupTables[6].columnDefs = LU_Tax.TableColumns(uoms);
            this.lookupTables[9].columnDefs = LU_VehicleType.TableColumns(false,true, this.mats);
          }
        );
      }
    );
    this.subscriptionArray.push(this.uomWatcherSubscription);

    this.taxWatcherSubscription = this.taxModelService.refreshTrigger$.subscribe(
      () => {
        this.taxModelService.getAllData(this.taxModelService.getAllUri).subscribe(
          (taxes) => {
            this.taxList = taxes;
          }
        );
      }
    );
    this.subscriptionArray.push(this.taxWatcherSubscription);

    this.termWatcherSubscription = this.termModelSvc.refreshTrigger$.subscribe(
      () => {
        this.termModelSvc.getAllData(this.termModelSvc.getAllUri).subscribe(
          (terms) => {
            this.termsList = terms;
          }
        );
      }
    );
    this.subscriptionArray.push(this.termWatcherSubscription);

    this.lookupTables.forEach((lt) => {
      const viewOptions = this.appGlobals.getViewOptions(lt.id);
      if (viewOptions) {
        viewOptions.optionsChanged = new Subject();
        lt.tableViewOpts = viewOptions;
      }
      this.subscriptionArray.push(
        lt.tableViewOpts.optionsChanged.subscribe((opts) => {
          const temp = opts.optionsChanged;
          opts.optionsChanged = undefined;
          this.appGlobals.setViewOptions(opts, lt.id);
          opts.optionsChanged = temp;
        })
      );
    });

    this.logTables.forEach((lt) => {
      const viewOptions = this.appGlobals.getViewOptions(lt.id);
      if (viewOptions) {
        viewOptions.optionsChanged = new Subject();
        lt.tableViewOpts = viewOptions;
      }
      this.subscriptionArray.push(
        lt.tableViewOpts.optionsChanged.subscribe((opts) => {
          const temp = opts.optionsChanged;
          opts.optionsChanged = undefined;
          this.appGlobals.setViewOptions(opts, lt.id);
          opts.optionsChanged = temp;
        })
      );
    });



    forkJoin([this.uomSvc.getAllData(this.uomSvc.getAllUri),
              this.taxModelService.getAllData(this.taxModelService.getAllUri),
              this.materialsServices.GetMaterialServiceTypes(),
              this.siteSvc.getAllData(this.siteSvc.getAllUri),
              this.gridModelService.getAllData(this.gridModelService.getAllUri),
              this.materialsServices.getAllData(this.materialsServices.getAllUri),
              this.termModelSvc.getAllData(this.termModelSvc.getAllUri)]).subscribe(
        ([uofms, taxes, matTypes, sites, grids, mats, terms]) => {
          this.matTypes = matTypes;
          this.grids = grids;
          this.mats = mats;
          var activeGrids = grids.filter(x => x.active == true)
          var activeMats = mats.filter(x => x.active == true)
          this.lookupTables[4].columnDefs = LU_MaterialService.TableColumns(false, uofms, matTypes, true, activeGrids);
          this.lookupTables[6].columnDefs = LU_Tax.TableColumns( uofms);
          this.lookupTables[9].columnDefs = LU_VehicleType.TableColumns(false,true,activeMats);
          this.taxList = taxes;
          this.termsList = terms;
          this.logTables[0].columnDefs = LU_InvoiceBatch.TableColumns(false, sites);
    });
  }

  ngOnDestroy() {
    this.subscriptionArray.forEach(
      (subscription) => {
        if (subscription) {
          subscription.unsubscribe();
        }
      }
    );
  }

  handleEditComplete(result) {
    if (!result.active) {
      switch (result.name) {
        case 'Contact Type':
          this.contactTypeService.triggerRefresh();
          break;
        case 'Grid':
          this.gridModelService.triggerRefresh();
          break;
        case 'Job Categories':
          this.jobCategoryService.triggerRefresh();
          break;
        case 'Job Codes':
          this.jobCodeService.triggerRefresh();
          break;
        case 'Materials Services':
          this.materialsServices.triggerRefresh();
          break;
        case 'Material Subcategories':
          this.matSubCategorySvc.triggerRefresh();
          break;
        case 'Taxes':
          this.taxModelService.triggerRefresh();
          break;
        case 'Terms':
          this.termModelSvc.triggerRefresh();
          break;
        case 'Unit of Measure':
          this.uomSvc.triggerRefresh();
          break;
        case 'Vehicle Type':
          this.vehicleTypeSvc.triggerRefresh();
          break;
        default:
          console.error('Edit Deactivate For Unkown Table');
      }
    }
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  isFieldEligibleForEdit(rowData, col: ITableColumn, editRow: boolean) {
    if (rowData.uid === 0) {
      return editRow && col.editableNew;
    } else {
      return editRow && col.editable;
    }
  }

  getDropdownData(col: DropdownTableColumn) {
    return col.dropdownData.eligibleArrayOfItems;
  }

  getDropdownDisplay(rowData, col: IDropdownTableColumn, editRow: boolean): string {
    return col.dropdownData.itemDisplayForRow(rowData, col.columnName, !editRow);
  }

  dropdownDisplay(item: ISelectable, col: IDropdownTableColumn | TableColumn): string {
    if ((col as IDropdownTableColumn).dropdownData) {
      return item[(col as IDropdownTableColumn).dropdownData.displayProperty];
    }
  }

  changeDropdownChosenItem(rowData, col: IDropdownTableColumn, item: ISelectable) {
    const bp = col.dropdownData.bindingProperty;
    rowData[col.columnName] = JSON.parse(JSON.stringify(item));
    rowData[col.outBindingProperty] = item[bp];
  }
}
